import {
    FormControl,
    Grid,
    InputLabel,
    Select,
    TextField,
    MenuItem,
} from "@mui/material";
import { useFormik } from "formik";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import * as yup from "yup";
import { useEffect } from "react";
import { resetVendors } from "../../Redux/VendorSlice/VendorSlice";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import {
    adderReset,
    CreateAdderMethod,
    GetAllServiceTypes,
} from "../../Redux/AddersSlice/AddersSlice";

const CreateAdder = () => {
    const dispatch = useDispatch();
    const { services, isLoading, isSuccess, isError, errors } = useSelector(
        (state) => state.adders
    );
    // const allServices = services || [];
    const allServices = [
        { name: "Solar" },
        { name: "Roofing" },
        { name: "Hvac" },
    ];
    const validationSchema = yup.object({});
    const formik = useFormik({
        initialValues: {
            name: "",
            service_type: "",
            submit: false,
            // state_vendor: {},
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            values.submit = true;

            await dispatch(CreateAdderMethod(values));
            await dispatch(adderReset());
        },
    });

    useEffect(() => {
        const GetAllServices = async () => {
            await dispatch(GetAllServiceTypes());
            await dispatch(adderReset());
        };
        GetAllServices();
    }, []);

    useEffect(() => {
        if (isError) {
            if (errors) {
                Object.keys(errors).forEach((key) => {
                    let error = errors[key][0];
                    toast.error(error);
                });
            }
            const reset = async () => {
                await dispatch(adderReset());
            };
            reset();
        }
    }, [dispatch, errors, isError]);

    useEffect(() => {
        if (isSuccess && formik.values.submit) {
            toast.success("Created successfully");
            formik.values.name = "";
        }
    }, [formik.values, isSuccess]);

    return (
        <>
            {isLoading && <LoadingAnimation />}
            {!isLoading && (
                <FormContainer>
                    <FormHeading> Add New Adder </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-label">
                                        Service Type
                                    </InputLabel>
                                    <Select
                                        id="service_type"
                                        name="service_type"
                                        label="Service Type"
                                        value={formik.values.service_type}
                                        onChange={formik.handleChange}
                                    >
                                        {allServices?.map((key, index) => (
                                            <MenuItem
                                                key={index}
                                                value={key.name}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="name"
                                    name="name"
                                    label="Name"
                                    value={formik.values.name}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.name &&
                                        Boolean(formik.errors.name)
                                    }
                                    helperText={
                                        formik.touched.name &&
                                        formik.errors.name
                                    }
                                />
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLoading ? "loading ... " : " Add New Adder"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreateAdder;
